import type { MultipleReceiptItem, SingleReceiptItem } from '@swf/core/models/sports/betSlip/types';

export const isSingleReceiptItem = (
  bet: SingleReceiptItem | MultipleReceiptItem
): bet is SingleReceiptItem => bet.type === 'SINGLE';

export const isSingleReceiptItems = (
  bets: SingleReceiptItem[] | MultipleReceiptItem[]
): bets is SingleReceiptItem[] => bets[0].type === 'SINGLE';
